module.exports = __webpack_public_path__ + "img/apart07.cda97b21.png";